/**
 * Alias target for bare `moment` imports (wired up in config/esbuild/config.js).
 *
 * Applies the VA locale customization (see ./moment-setup) to the shared moment
 * instance and re-exports it, so every consumer of `moment` automatically gets
 * the correct locale formatting (e.g. "a.m."/"Sept.") without each app having to
 * import moment-setup.
 *
 * Because this module is only pulled in when something imports `moment`, moment
 * stays out of bundles that don't use it.
 *
 * NOTE: This module is intentionally authored as CommonJS. Some consumers reach
 * `moment` through `require('moment')` (e.g. the moment-timezone UMD factory in
 * personalization/dashboard/lib/moment-tz.js, which does
 * `factory(require('moment'))`). If this wrapper were an ESM module with a
 * default export, esbuild's CJS interop would make `require('moment')` resolve
 * to the module namespace object (`{ default: fn }`) instead of the callable
 * moment function, breaking those consumers at runtime. Using `module.exports`
 * makes `require('moment')` return the function directly, while ESM
 * `import moment from 'moment'` still gets the function via default-interop.
 */

// Side-effect require: applies `moment.updateLocale(...)` to the singleton
// before it is used anywhere.
require('./moment-setup');

// Re-export the real moment by subpath so the bare-`moment` alias does not loop.
// eslint-disable-next-line import/extensions
module.exports = require('moment/moment.js');
